import React from "react";

const NotFoundPage = () => (
  <div style={{ padding: "50px", textAlign: "center" }}>
    <h1>404 - Halaman Tidak Ditemukan</h1>
    <p>Periksa kembali URL yang Anda tuju.</p>
  </div>
);

export default NotFoundPage;
